module.exports = __webpack_public_path__ + "static/img/4.b85a7b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/4.png
// module id = 7pqd
// module chunks = 0